/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/function-component-definition */
import { useFieldComponent, useFieldsValue } from '@micromag/core/contexts';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    value: PropTypes.shape({
        domain: PropTypes.string,
    }),
    onChange: PropTypes.func,
};

const defaultProps = {
    value: null,
    onChange: null,
};

function KioskSubscriptionsField(props) {
    const Checkboxes = useFieldComponent('checkboxes');
    const { kiosk = null } = useFieldsValue() || {};
    const { subscriptions } = kiosk || {};

    return kiosk !== null ? (
        <Checkboxes
            {...props}
            options={(subscriptions || []).map(({ id, label }) => ({
                value: id,
                label,
            }))}
        />
    ) : <div>-</div>;
}

KioskSubscriptionsField.propTypes = propTypes;
KioskSubscriptionsField.defaultProps = defaultProps;

export default KioskSubscriptionsField;
